import { render, staticRenderFns } from "./InvestorProfile.vue?vue&type=template&id=4f4312c8&scoped=true&"
import script from "./InvestorProfile.vue?vue&type=script&lang=js&"
export * from "./InvestorProfile.vue?vue&type=script&lang=js&"
import style0 from "./InvestorProfile.vue?vue&type=style&index=0&id=4f4312c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4312c8",
  null
  
)

export default component.exports